const AboutIcon = ({ stroke = "rgb(246, 171, 11)", fill = "none" }) => (
  <svg
    width="34"
    viewBox="0 0 128 65"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    stroke={stroke}
    strokeWidth="4"
  >
    <g transform="translate(0, 13)">
      <ellipse cx="19.366" cy="11.529" rx="10.353" ry="10.529" />
      <path
        d="M0,50.864 C0.261,47.488 1.345,40.819 4.628,36.86 C7.599,33.276 11.523,30.31 19.5,30.31 C26.243,30.31 31.368,33.636 33.763,36.86 C36.158,40.084 37.945,43.392 39,50.864"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </g>
    <g transform="translate(87, 13)">
      <ellipse cx="19.366" cy="11.529" rx="10.353" ry="10.529" />
      <path
        d="M0,50.864 C0.261,47.488 1.345,40.819 4.628,36.86 C7.599,33.276 11.523,30.31 19.5,30.31 C26.243,30.31 31.368,33.636 33.763,36.86 C36.158,40.084 37.945,43.392 39,50.864"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </g>
    <g transform="translate(43, 0)">
      <ellipse cx="19.366" cy="11.529" rx="10.353" ry="10.529" />
      <path
        d="M0,50.864 C0.261,47.488 1.345,40.819 4.628,36.86 C7.599,33.276 11.523,30.31 19.5,30.31 C26.243,30.31 31.368,33.636 33.763,36.86 C36.158,40.084 37.945,43.392 39,50.864"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </g>
  </svg>
);

export default AboutIcon;